import './App.css';
import CheckerForm from './CheckerForm';

function handleResult(state) {
  if (state.isShitcoin) {
    document.body.classList.remove('not-shitcoin');
    document.body.classList.add('is-shitcoin');
  } else {
    document.body.classList.remove('is-shitcoin');
    document.body.classList.add('not-shitcoin');
  }
}

function handleChange(state) {
  document.body.classList.remove('not-shitcoin', 'is-shitcoin');
}

function App() {
  return (
    <div className="App bg-dark text-white">
      <div className="d-flex flex-column align-items-center justify-content-center text-center min-vh-100">
        <div className="animate__animated animate__fadeIn">
          <h1 className="display-6">shitcoin.fi</h1>
          <p className="lead text-muted">The easy way to check if it's a shitcoin</p>
          <CheckerForm onFormChange={handleChange} onCheckResult={handleResult} />
        </div>
      </div>
    </div>
  );
}

export default App;